export default __webpack_public_path__ + "static/cristian@2x-7dbb2062a395b31837d11755f58a0c63.jpg";